import {Component, OnInit, ViewChild} from '@angular/core';
import {Log} from '../../../models/models';
import {LoginService} from '../../../services/login.service';
import {CheckService} from '../../../services/check.service';
import {DamageAdministrationService} from '../../../services/damage-administration.service';
import {ClickEventArgs} from '@syncfusion/ej2-angular-navigations';
import {GridComponent} from '@syncfusion/ej2-angular-grids';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-damage-administration-logs',
  templateUrl: './damage-administration-logs.component.html',
  styleUrls: ['./damage-administration-logs.component.css']
})
export class DamageAdministrationLogsComponent implements OnInit {

  @ViewChild('damageAdministrationLogsGrid', {static: true}) private damageAdministrationLogsGrid: GridComponent;

  public locale: string;
  public dataSource: Log[] = [];
  public toast = Swal.mixin({toast: true, position: 'top-right', timer: 2000, timerProgressBar: false, showConfirmButton: false});
  

  constructor(
    private loginService: LoginService,
    private checkService: CheckService,
    private damageAdministrationService: DamageAdministrationService,
  ) { }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.loginService.checkToken();
    this.checkService.checkRight(14);
    this.loadDataSource();
  }


  loadDataSource() {
    this.damageAdministrationService.getLogs().subscribe(response => {
      if (response.Ok) {
        this.dataSource = response.Obj;
        this.initGrid();
      }
      if (response.Ex) console.log(response.Ex);
      if (response.Msg) this.toast.fire('', response.Msg, response.Ok ? 'success' : 'error');
    }), (error: any) => {
      console.log(error);
      this.toast.fire('Fehler', 'Interner Serverfehler', 'error');
    };
  }

  initGrid() {
    this.damageAdministrationLogsGrid.allowExcelExport = true;
    this.damageAdministrationLogsGrid.allowPdfExport = true;
    this.damageAdministrationLogsGrid.allowPaging = true;
    this.damageAdministrationLogsGrid.pageSettings = {pageCount: 5, pageSize: 15};
    this.damageAdministrationLogsGrid.toolbar = ['ExcelExport', 'PdfExport', 'Print', 'Search'];
    this.damageAdministrationLogsGrid.editSettings = {allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal'};
  }

  toolbarClick($event: ClickEventArgs) {
    if ($event.item.id === 'damageAdministrationLogsGrid_excelexport') {
      this.damageAdministrationLogsGrid.excelExport();
    }
    if ($event.item.id === 'damageAdministrationLogsGrid_pdfexport') {
      this.damageAdministrationLogsGrid.pdfExport();
    }
  }
}
